import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './ThankYouPage.css';

const ThankYouPage = () => {
    const location = useLocation();
    const trackingToken = location.state?.trackingToken;
    const trackingPath = trackingToken ? `/apply/track/${trackingToken}` : null;

    const backgroundStyle = {
        backgroundColor: '#0c001f',
        backgroundImage: `
            radial-gradient(at 20% 20%, hsla(28,100%,74%,0.15) 0px, transparent 50%),
            radial-gradient(at 80% 20%, hsla(217,100%,50%,0.15) 0px, transparent 50%),
            radial-gradient(at 80% 80%, hsla(339,100%,50%,0.15) 0px, transparent 50%),
            radial-gradient(at 20% 80%, hsla(140,100%,50%,0.15) 0px, transparent 50%)
        `,
    };

    return (
        <div
            className="thank-you-page"
            style={{
                ...backgroundStyle,
                color: '#f5f5f5',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem',
            }}
        >
            <div className="thank-you-container">
                <div className="thank-you-icon">✓</div>
                <h1>Thank You!</h1>
                <p>Your application has been submitted successfully.</p>
                <p>We will review your application and get back to you soon.</p>
                {trackingPath && (
                    <Link to={trackingPath} className="thank-you-track-button">
                        Start tracking your application
                    </Link>
                )}
            </div>
        </div>
    );
};

export default ThankYouPage;
